import { ComponentBaseConfigModel } from '../component-base-config.model';

export interface TocConfigModel extends ComponentBaseConfigModel {
  showEditLayerIcon?: boolean;
}
